export default {
	
	dynamic: [
		{
			key: '8c9e39ea_00ef_4a2d_a9ea_ae1db4c4d16b1639359900133',
			preview: 'https://vybbasevr.vyb.cn/8c9e39ea_00ef_4a2d_a9ea_ae1db4c4d16b1639359900133',
			thumb: 'https://vybbasevr.vyb.cn/3226d1ab_5422_452b_a763_628ec09e86e61639452367599',
			width: 110,
			height: 110,
			scale: 0.5
		},
		{
			key: '12d.png',
			preview: 'https://vybbasevr.vyb.cn/12d.png',
			thumb: 'https://vybbasevr.vyb.cn/12.png',
			width: 128,
			height: 128,
			scale: 0.5
		},
	],
	static: [
		{
			key: '38ee4cfb_0974_4484_8be6_334cbe894d4e1639451420770',
			preview: 'https://vybbasevr.vyb.cn/38ee4cfb_0974_4484_8be6_334cbe894d4e1639451420770',
			thumb: 'https://vybbasevr.vyb.cn/38ee4cfb_0974_4484_8be6_334cbe894d4e1639451420770',
			width: 110,
			height: 110,
			scale: 0.5
		},
		{
			key: '44f61bb7_be7e_4fc8_9fa0_dc5109599cd31639451439014',
			preview: 'https://vybbasevr.vyb.cn/44f61bb7_be7e_4fc8_9fa0_dc5109599cd31639451439014',
			thumb: 'https://vybbasevr.vyb.cn/44f61bb7_be7e_4fc8_9fa0_dc5109599cd31639451439014',
			width: 110,
			height: 110,
			scale: 0.5
		}
	]
}